import { login, logout } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";

import { encrypt } from "@/utils/jsencrypt";
import { getLoginInfo } from "@/api/info";

const user = {
  state: {
    token: getToken(),
    id: "",
    name: "",
    avatar: "",
    roles: [],
    permissions: [],
    sysInfo: {},
    userName: "请登录",
    user: {
      DETAILED_ADDRESS: "",
      EDUCATION_LEVEL: "",
      EMAIL: "",
      EMPLOYER: "",
      GENDER: "",
      IDENTITY: "",
      ID_NUMBER: "",
      ID_TYPE: "",
      MAJOR_ATTENDED: "",
      MOBILE_PHONE: "",
      NAME: "请登录",
      ORG_ID: null,
      PASSWORD: null,
      PHOTO: "[]",
      SCHOOL_ATTENDED: "",
      USER_ID: "",
      createTime: null,
      createUser: null,
      id: "",
      isDelete: null,
      tbId: "",
    },
    firstLogin: true, // 是否初次登录

    orgId: "",
    orgName: "",
    // 用于个人信息更改后，其他页面的更新
    updateFlag: false,

    // 是否已经登出
    isOut: true,
    // 修改密码弹窗是否已显示
    showChangePasswordDialog: false,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    SET_SYSINFO: (state, sysInfo) => {
      state.sysInfo = sysInfo;
    },
    SET_FLAG: (state, updateFlag) => {
      state.updateFlag = updateFlag;
    },
    SET_USER: (state, user) => {
      state.user = user;
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName;
    },
    SET_ORGID: (state, orgId) => {
      state.orgId = orgId;
    },
    SET_ORGNAME: (state, orgName) => {
      state.orgName = orgName;
    },
    // 设置是否登出
    SET_OUT: (state, isOut) => {
      state.isOut = isOut;
    },
    // 设置初次登录
    SET_FIRST_LOGIN: (state, firstLogin) => {
      state.firstLogin = firstLogin;
    },

    SET_SHOW_CHANGE_PASSWORD_DIALOG: (state, showChangePasswordDialog) => {
      state.showChangePasswordDialog = showChangePasswordDialog;
    },
    SET_TBID: (state, tbid) => {
      state.tbid = tbid;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      const password = encrypt(userInfo.password);
      const code = userInfo.code;
      const uuid = userInfo.uuid;
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid)
          .then((res) => {
            const token = res.data.token;
            setToken(token);
            commit("SET_TOKEN", token);
            commit("SET_OUT", false);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setToken({ commit }, token) {
      return new Promise((resolve) => {
        setToken(token);
        commit("SET_TOKEN", token);
        commit("SET_OUT", false);
        resolve();
      });
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getLoginInfo()
          .then((res) => {
            if (res.code !== 200) {
              commit("SET_OUT", true);
              resolve(res);
            }
            const user = res.data || {};
            let avatar = '';
            try {
              let tempJson = JSON.parse(res.data.PHOTO);
              console.log(tempJson);
              if (tempJson[0].id) {
                avatar = "/system/file/download?uuid=" + tempJson[0].id;
              } else {
                avatar = '';
              }
            } catch (e) {
              console.log(e);
              avatar = '';
            }
            if (user.ID_TYPE) {
              if (user.ID_TYPE === "value1") {
                user.ID_TYPE = "身份证";
              } else if (user.ID_TYPE === "value2") {
                user.ID_TYPE = "护照";
              } else if (user.ID_TYPE === "value3") {
                user.ID_TYPE = "驾驶执照";
              } else if (user.ID_TYPE === "value4") {
                user.ID_TYPE = "学生证";
              } else {
                user.ID_TYPE = "其他";
              }
            }
            if (user.EDUCATION_LEVEL) {
              if (user.EDUCATION_LEVEL === "value1") {
                // user.EDUCATION_LEVEL = '高中及以下'
              } else if (user.EDUCATION_LEVEL === "value2") {
                user.EDUCATION_LEVEL = "专科";
              } else if (user.EDUCATION_LEVEL === "value3") {
                user.EDUCATION_LEVEL = "本科";
              } else if (user.EDUCATION_LEVEL === "value4") {
                user.EDUCATION_LEVEL = "硕士";
              } else if (user.EDUCATION_LEVEL === "value5") {
                user.EDUCATION_LEVEL = "博士";
              } else {
                user.EDUCATION_LEVEL = "其他";
              }
            }
            if (user.IDENTITY) {
              if (user.IDENTITY === "value1") {
                user.IDENTITY = "在校学生";
              } else if (user.IDENTITY === "value2") {
                user.IDENTITY = "在校工作人员";
              } else {
                user.IDENTITY = "社会人员";
              }
            }
            console.log(avatar);
            commit("SET_AVATAR", avatar);
            commit("SET_USER", user);

            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        console.log("LogOut", state.isOut);
        if (state.isOut) resolve();

        const clearLocalAuthInfo = () => {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          commit("SET_PERMISSIONS", []);
          removeToken();
        };

        commit("SET_OUT", true); // 记录登出

        logout(state.token)
          .then(() => {
            clearLocalAuthInfo();
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            clearLocalAuthInfo();
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        removeToken();
        resolve();
      });
    },

    // 设置标志
    setUpdateFlag({ commit }, updateFlag) {
      commit("SET_FLAG", updateFlag);
    },

    setShowChangePasswordDialog({ commit }, showChangePasswordDialog) {
      commit("SET_SHOW_CHANGE_PASSWORD_DIALOG", showChangePasswordDialog);
    },
  },
};

export default user;
